import { useState } from "react";
import {
  FaServer,
  FaDatabase,
  FaCode,
  FaProjectDiagram,
  FaAws,
  FaCogs,
  FaCubes,
  FaLaptopCode,
  FaFlask,
  FaCheckCircle,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Banner from "../components/Banner.js";
import DiagramPicture from "../assets/DBES.png";
import malePhoto from "../assets/avater-man.avif";
import femalePhoto from "../assets/avater-women.avif";
import { BsEye, BsEyeSlash, BsGithub, BsLinkedin } from "react-icons/bs";
import { FaBagShopping } from "react-icons/fa6";  
import ProgramStructure from "../components/courseDetails/ProgramStructure.js";
import { Link } from "react-router-dom";
import InstructorCard from "../components/InstructorCard.js";
import LazyImage from "../components/courseDetails/LazyImageLoader.js";
import ScholarshipAgreementModal from "../components/courseDetails/ScholarshipAgreement";
import WhyProgramSection from "../components/courseDetails/WhyProgramSection.js";

// import { Button } from "@/components/ui/button";
// const defaultPhoto = "https://via.placeholder.com/100?text=No+Image"; // Use your own default image URL




export default function Training() {
  const [showProgram, setShowProgram] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  // const [activeBatch, setActiveBatch] = useState("BES-BTH-02")
  const [scholarshipStudents] = useState([
    {
      name: "Al Imran",
      university: "Govt. Saadat College",
      department: "Islamic Study's",
      batch: "BES-BTH-02",
      gender: "male",
      links: [
        {
          name: "github",
          link: "https://github.com/imran0dot",
          icon: <BsGithub />,
        },
        {
          name: "linkedin",
          link: "https://www.linkedin.com/in/imran0dot/",
          icon: <BsLinkedin />,
        },
      ],
      photo: malePhoto,
    },
    {
      name: "Mahin Jaman",
      university: "Shariatpur Polytechnic Institute",
      department: "Computer Science & Technology",
      batch: "BES-BTH-02",
      links: [
        {
          name: "github",
          link: "https://github.com/mahinjaman",
          icon: <BsGithub />,
        },
        {
          name: "linkedin",
          link: "https://www.linkedin.com/in/mahin-jaman",
          icon: <BsLinkedin />,
        },
      ],
      photo: malePhoto,
    },
    // {
    //   name: "Sharmin Akter",
    //   university: "National University",
    //   department: "English",
    //   batch: "BES-BTH-02",
    //   links: [
    //     {
    //       name: "github",
    //       link: "https://github.com/Sharminaktermetu",
    //       icon: <BsGithub />,
    //     },
    //     {
    //       name: "linkedin",
    //       link: "https://www.linkedin.com/in/sharmin-akter-metu/",
    //       icon: <BsLinkedin />,
    //     },
    //   ],
    //   photo: femalePhoto,
    // },
    // {
    //   name: "Your Name",
    //   university: "Your University",
    //   department: "EEE",
    //   batch: "BES-BTH-02",
    //   photo: femalePhoto,
    //   gender: "female",
    // },
    // Only 2 filled. So 1 slot left.
  ]);
  const totalScholarships = 3;
  const slotsLeft = totalScholarships - scholarshipStudents.length;

  return (
    <>
      <Banner isTraning={true} />
      <div className="container flex flex-col gap-5">
        {/* Hero Section */}
        <section className="py-5 px-4 md:px-12">
          <h2 className="text-4xl font-bold text-center">আসসালামু আলাইকুম!</h2>
          <h3 className="text-4xl font-bold text-center py-3 text-[#FF30AF]">Learn Like an Institute. Build Like the Industry.</h3>
          <p className="text-lg text-gray-600 mb-5 text-left">
            আপনি কি নন-সিএসই ব্যাকগ্রাউন্ড থেকে এসেছেন? এইচএসসি পাস করেছেন, অথবা
            বর্তমানে প্রথম সেমিস্টারে আছেন? আপনি কি চান আগামী ১ বছরের মধ্যে
            নিজেকে একজন দক্ষ সফটওয়্যার ইঞ্জিনিয়ার হিসেবে দেখতে?
          </p>
          <p className="text-lg font-semibold text-gray-600 mb-5 text-left">
            {" "}
            যদি উত্তর হয় হ্যাঁ,{" "}
          </p>
          <p className="text-lg text-gray-600 mb-5 text-left">
            তাহলে এই ট্রেনিং প্রোগ্রামটি Non-CSE থেকে Real-World Backend
            Engineer হওয়ার বাস্তব প্রস্তুতি — বিশেষভাবে তৈরি এই প্রোগ্রামটি শুধু
            আপনার জন্য! কোর্সটি বিশেষভাবে তৈরি করা হয়েছে কম্পিউটার সায়েন্স ব্যাকগ্রাউন্ড ছাড়া 
            এমন শিক্ষার্থীদের জন্য, যারা আগামী ১ বছরের মধ্যে নিজেদেরকে একজন দক্ষ ব্যাকএন্ড ইঞ্জিনিয়ার হিসেবে দেখতে চান 
            এবং এর জন্য পরিশ্রম ও সময় দিতে প্রস্তুত।
            
            আমরা জানি, আপনি শুরুটা শূন্য থেকে করছেন এবং আপনি হয়তো
            কোডিং আগে কখনও শিখেননি। আর সেই কারণেই — আমরা এমনভাবে পরিকল্পনা করেছি
            এই প্রোগ্রাম, যা ধাপে ধাপে আপনাকে একজন পুরোদস্তুর ব্যাকএন্ড
            ইঞ্জিনিয়ার বানাবে, ইন শা আল্লাহ।
          </p>

          <p className="text-lg font-semibold text-gray-600 mb-5 text-left" >যাদের জন্য এই কোর্সটি উপযুক্ত</p>
          <ul className="space-y-2 text-gray-700 list-disc list-inside pb-5">
            <li> যাঁরা ফুল টাইম শেখার জন্য প্রতিদিন ৫-৬ ঘণ্টা সময় দিতে প্রস্তুত</li>
            <li>যাঁদের লক্ষ্য ১ বছরের মধ্যে সফটওয়্যার ইন্ডাস্ট্রিতে প্রবেশ করা</li>
            <li>
              যারা বিশ্বাস করেন যে ব্যাকগ্রাউন্ড কোনো বাধা নয়, প্রস্তুতি-ই সাফল্যের চাবিকাঠি
            </li>
          </ul>

          <div className="flex flex-col gap-4">
            <div>
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                এই প্রোগ্রামের বিশেষত্ব কী?
              </h3>
              <ul className="space-y-2 text-gray-700 list-disc list-inside pb-5">
                <li>পুরো কোর্সটি সাজানো হয়েছে ইন্ডাস্ট্রির প্রয়োজনীয়তা ও স্ট্যান্ডার্ড অনুযায়ী</li>
                <li>
                  একদম শুরু থেকে শেখানো হবে – প্রোগ্রামিং সম্পর্কে কোনো অভিজ্ঞতা
                  না থাকলেও চিন্তা নেই।
                </li>
                <li>
                  ধাপে ধাপে গাইডলাইন – প্রতিটি টপিক সহজ ভাষায় ও সুস্পষ্টভাবে
                  শেখানো হবে।
                </li>
                <li>
                  প্র্যাকটিক্যাল লার্নিং – শুধুমাত্র দেখিয়ে না, আপনি নিজে করে
                  শিখবেন।
                </li>
                <li>প্রতিটি স্কিলে রোল নির্ভর Outcome নিশ্চিত করা হয়।</li>
                <li>
                  সহযোগিতাপূর্ণ পরিবেশ – গ্রুপ সাপোর্ট, প্রশ্নোত্তর, ও হেল্প
                  ডেস্ক থাকবে যেন আপনি কোনো কনফিউশনে না থাকেন।
                </li>
                <li>
                  মেন্টর ও মোটিভেশন – নিয়মিত গাইডলাইন ও অনুপ্রেরণা পাবেন যাতে
                  আপনি ঠিক পথে থাকতে পারেন।
                </li>
                <li>
                  এই প্রোগ্রামই হবে আপনার Non-CSE থেকে CSE লেভেলে রূপান্তরের
                  সবচেয়ে কার্যকর মাধ্যম
                </li>
                <li>
                  রিয়েল ওয়ার্ল্ড সফটওয়্যার কোম্পানিতে যা লাগে, আমরা সেটাই শেখাই
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                নন-সিএসই স্টুডেন্টদের জন্য এটা কেন পারফেক্ট?
              </h3>
              <p className="text-gray-600 mb-5">
                আমরা জানি সবাই প্রোগ্রামিং ব্যাকগ্রাউন্ড থেকে আসে না। তাই —
              </p>
              <ul className="space-y-2 text-gray-700 list-disc list-inside">
                <li>প্রতিটি ক্লাস হবে সহজ, পরিষ্কার ও বুঝতে সুবিধাজনক।</li>
                <li>
                  প্রতিটি টপিক শেখানো হবে একদম বেসিক থেকে, বাস্তব উদাহরণ দিয়ে
                </li>
                <li>আপনি কখনোই প্রেশারে পড়বেন না।</li>
                <li>হাতে-কলমে শেখানো হবে, তাই বাস্তব অভিজ্ঞতা হবে।</li>
                <li>
                  সিএসই স্টুডেন্টদের সঙ্গে আত্মবিশ্বাসের সঙ্গে প্রতিযোগিতা করার
                  মতো দক্ষতা তৈরি হবে।
                </li>
                <li>
                  ব্যাকএন্ড ইঞ্জিনিয়ার হিসেবে যা যা জানতে হয়, আপনি সবকিছু
                  হাতে-কলমে শিখবেন
                </li>
                <li>
                  CSE গ্র্যাজুয়েট যা জানে, আপনি জানবেন তারও বেশি — হাতে-কলমে
                  স্কিলে
                  <ul className="space-y-2 text-gray-700 list-disc list-inside">
                    <li>--- তারা পড়ে প্রজেক্ট বানায়</li>
                    <li>--- আপনি শিখে নিজের হাতে বানাবেন প্রজেক্ট</li>
                    <li>--- তারা বুঝে থিওরি</li>
                    <li>--- আপনি শিখবেন বাস্তব সফটওয়্যার কিভাবে চলে</li>
                  </ul>
                </li>
              </ul>
              <p className="py-5 font-semibold text-lg text-gray-600 text-left">
                এটাই হবে আপনার পার্থক্য। এটাই হবে আপনার শক্তি।
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                আমাদের প্রতিশ্রুতি — গ্যারান্টিসহ
              </h3>
              <ul className="space-y-2 text-gray-700 list-disc list-inside">
                <li>আপনি যদি নিয়মিত ক্লাস করেন</li>
                <li>অ্যাসাইনমেন্ট ও প্রজেক্টগুলো ঠিকভাবে করেন</li>
                <li>সাপোর্ট ও গাইডলাইন ফলো করেন</li>
              </ul>
              <p className="py-5 font-semibold text-lg text-gray-600 text-left">
                তাহলে ইন শা আল্লাহ, আপনি ১ বছরের মধ্যে একজন প্রফেশনাল লেভেলের
                ব্যাকএন্ড ডেভেলপার হয়ে উঠবেন — এই আমাদের গ্যারান্টি।
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                আমাদের লক্ষ্য
              </h3>
              <p className="text-gray-600 mb-10 font-semibold">
                আগামী ১ বছরের মধ্যে আপনাকে সফটওয়্যার ইঞ্জিনিয়ার হিসেবে গড়ে
                তোলা — যেন আপনি চাকরি পাওয়ার জন্য প্রস্তুত থাকেন। CSE না পড়েও
                আপনি একজন সফটওয়্যার ইঞ্জিনিয়ার হতে পারেন — এই বিশ্বাসটাই আমরা
                বাস্তবে রূপ দিতে চাই। আমরা শুধু শেখাবো না — আমরা বদলে দিতে চাই
                আপনার ক্যারিয়ার, ইন শা আল্লাহ।
              </p>
            </div>

            <div className="bg-white rounded-xl">
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                কমপ্লিট ক্যারিয়ার রোডম্যাপ – সাকসেস অথবা ক্যাশ ব্যাক!
              </h3>

              <p className="text-gray-600 mb-10 font-semibold">
                এই ট্রেনিং প্রোগ্রাম শুধুই একটি কোর্স না — এটি একটি পূর্ণাঙ্গ ক্যারিয়ার রোডম্যাপ। আমরা গ্যারান্টি দিচ্ছি, আপনি যদি প্রতিটি ধাপ মনোযোগ দিয়ে শেষ করেন — আপনি হবেন একজন Job-Ready Backend Software Engineer। ইন শা আল্লাহ। যদি না পারেন — রয়েছে ক্যাশ ব্যাক অথবা স্কলারশিপে পরবর্তী সাপোর্ট সুবিধা।
              </p>

              <blockquote className="border-l-4 border-indigo-500 pl-5 py-5 bg-indigo-50 rounded-md shadow-sm text-gray-800">
                <p className="text-lg sm:text-xl font-semibold leading-relaxed italic">
                  <strong>If you follow the process</strong> — and still don’t become job-ready —
                  <span className="text-indigo-700 font-bold"> we’ll give your money back</span>.
                </p>
                <p className="mt-3 text-lg sm:text-xl font-medium">
                  Because this isn’t about selling a course —
                  it’s about <span className="text-green-700 font-bold">building engineers</span>
                  <span className="text-gray-600 font-semibold"> with </span>
                  <span className="text-purple-700 font-extrabold">results or refunds.</span>
                </p>
              </blockquote>
            

              <p className="text-gray-700 py-5 text-lg sm:text-xl font-medium leading-relaxed">
                <span className="text-purple-700 font-bold">Our Promise = Your Power</span><br />
                🧾 Attend. <br />
                👨‍💻 Build. <br />
                🚀 Launch. <br />
                Or walk away with your investment fully returned.
              </p>
            </div>

            <div className="bg-white rounded-md shadow-md p-6 sm:p-8 text-gray-800 space-y-4">
              <p className="text-lg sm:text-xl font-semibold leading-relaxed">
                <span className="text-green-700 font-bold">You won’t lose money.</span><br />
                <span className="text-red-600 font-bold">You’ll only lose the chance —</span> <br className="hidden sm:block" />
                <span className="italic text-gray-700">if you don’t start.</span>
              </p>

              <p className="text-indigo-700 text-xl font-bold mt-4 flex items-center gap-2">
                📢 Apply Now —
                <span className="text-purple-700">Because Career-Driven Engineers Are Made Here.</span>
              </p>
            </div>
            <section className="bg-gradient-to-r from-indigo-100 via-purple-100 to-pink-100 rounded-2xl px-6  md:py-10 md:px-5 text-center shadow-sm border border-purple-200 ">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4 leading-snug">
                One place. One path. <span className="text-purple-600">Infinite possibilities.</span>
              </h2>
              <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
                Build your future with clarity, guidance, and real engineering skills — all in one focused journey.
              </p>
            </section>
            <div className="bg-white rounded-xl">
              <div className="w-full mx-auto">
                <LazyImage
                  srcWebp={DiagramPicture}
                  srcFallback={malePhoto}
                  alt="Career Roadmap Guarantee"
                  className="w-full rounded-xl shadow-md object-cover"
                />
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-indigo-700">
                এই কোর্স কারা করতে পারেন?
              </h3>
              <ul className="space-y-2 text-gray-700 list-disc list-inside">
                <li>Non-CSE ইউনিভার্সিটি স্টুডেন্ট যারা কোডিং শুরু করতে চান</li>
                <li>
                  Diploma/Polytechnic শিক্ষার্থী যারা সফটওয়্যার ইন্ডাস্ট্রিতে
                  আসতে চান
                </li>
                <li>
                  যারা প্রোগ্রামিংয়ে আগ্রহী, কিন্তু কোথা থেকে শুরু করবেন বুঝতে
                  পারছেন না
                </li>
                <li>
                  যারা শুধুই “টিউটোরিয়াল দেখে শিখছি” কিন্তু গভীরভাবে বুঝতে
                  পারেননি
                </li>
                <li>যারা এইচএসসি (বিজ্ঞান) সমাপ্ত করেছেন অথবা সিএসই বিষয়ে অধ্যয়নরত 
                  (প্রথম সেমিস্টারে আছেন কিংবা অধ্যয়ন করছেন কিন্তু হতাশ বোধ করছেন এবং ভাবছেন এই 
                  সাবজেক্টটি হয়তো আপনার জন্য নয়), অথচ সফটওয়্যার ইঞ্জিনিয়ারিং পেশার প্রতি আগ্রহী—এই 
                  প্রোগ্রামটি তাদের জন্য।
                </li>
              </ul>
            </div>

          </div>

         

          <div className="py-5 space-y-5">
            {/* Outcomes */}
            <div className="rounded-2xl p-6 bg-red-100">
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                ভর্তির আগে গুরুত্বপূর্ণ কিছু বিষয়
              </h3>
              <ul className="space-y-2 text-gray-700 list-disc list-inside font-semibold">
                <li>আপনি যদি বর্তমানে কোনো চাকরিতে থাকেন, তাহলে দুঃখিত – এই প্রোগ্রামটি আপনার জন্য নয়।</li>
                <li>প্রতিদিন ৫-৬ ঘণ্টা সময় দিতে হবে, যা বাধ্যতামূলক।</li>
                <li>সব ক্লাস দিনের বেলা অনুষ্ঠিত হবে, রাতের বেলা কোনো ক্লাস থাকবে না।</li>
                <li>বয়স ৩০ বছরের বেশি হওয়া যাবে না।</li>
              </ul>
            </div>
          </div>

        </section>
        

        <section className="py-8 px-4 md:px-12 bg-gray-50">
          <h2 className="text-4xl font-bold mb-6 text-center">
            About the Program
          </h2>
          <p className="text-lg text-gray-600 mb-10 text-left">
            The <strong>Backend Engineering Program</strong> is meticulously
            structured to equip learners with industry-ready skills through a
            progressive, hands-on curriculum. The content is divided into three
            comprehensive phases — each designed to build depth, practical
            expertise, and confidence in modern backend engineering.
          </p>

           <WhyProgramSection />
           <br/>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {phases.map((phase, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-blue-700 mb-4">
                  {phase.title}
                </h3>
                <ul className="text-gray-700 text-sm space-y-2 list-disc list-inside whitespace-pre-line">
                  {phase.description
                    .trim()
                    .split("\n")
                    .filter((line) => line.trim() !== "")
                    .map((line, idx) => (
                      <li key={idx}>{line.replace("-", "").trim()}</li>
                    ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="space-y-5">
            {/* Outcomes */}
            <div className="rounded-2xl p-6">
              <h3 className="text-2xl font-semibold text-indigo-700 mb-4">
                🏁 Program Outcomes
              </h3>
              <ul className="space-y-2 text-gray-700 list-disc list-inside">
                <li>Build and deploy production-grade backend systems</li>
                <li>
                  Master backend technologies from fundamentals to cloud-native
                </li>
                <li>Develop portfolio-worthy capstone projects</li>
                <li>
                  Get ready for roles like Backend Developer, Database Design & Architecture, Database Developer/MySQL Developer/SQL Programmer, Data Analyst with SQL Expertise, DevOps
                  Engineer(Junior), Software Tester, Data Engineering(Junior) and System Architect
                </li>
              </ul>
            </div>
          </div>

        </section>

        <section className="bg-gray-50 py-5 px-4 sm:px-6 lg:px-5">
          <div className="max-w-7xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
              Why Take This Program?
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              A full stack backend engineering curriculum designed to get you
              job-ready.
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start space-x-3 mb-4">
                  <FaCheckCircle className="text-green-600 w-6 h-6 mt-1" />
                  <h3 className="text-xl font-semibold text-gray-800">
                    {item.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Program Structure Toggle */}
        <section className="sm:px-6 lg:px-5">
          <div className="flex justify-between items-center">
            <h2>Program Structure</h2>
            <button onClick={() => setShowProgram(!showProgram)}>
              {showProgram ? (
                <div className="flex gap-2 items-center justify-center text-lg font-bold bg-slate-100 m-4 p-4">
                  <p className="lg:block hidden">Hide Details</p>{" "}
                  <span>
                    {" "}
                    <BsEyeSlash />
                  </span>
                </div>
              ) : (
                <div className="flex gap-2 items-center justify-center text-lg font-bold bg-slate-100 m-4 p-4">
                  <p className="lg:block hidden">Show Details</p>{" "}
                  <span>
                    {" "}
                    <BsEye />
                  </span>
                </div>
              )}
            </button>
          </div>
          {showProgram && (
            <div className="overflow-x-auto mt-4 border rounded-lg">
              <ProgramStructure />
            </div>
          )}
        </section>
        {/* Capstone Projects */}
        {/* <section>
          <div>
            <h2>Capstone Projects</h2>
            <ul className="space-y-4 list-none list-inside text-lg">
              {projects.map((proj, idx) => (
                <p key={idx} className="border p-4 rounded-lg">
                  <h3><FaCheckCircle className="inline mr-2 text-green-600" /> {proj.title}</h3>

                  {proj.details.map((d, i) => (
                    <li key={i} className="px-9 list-disc list-inside">
                      {d}
                    </li>
                  ))}
                </p>
              ))}
            </ul>
          </div>
        </section> */}
        {/* Labs and Tech Stack */}
        <section className="sm:px-6 lg:px-5">
          <h2>
            <FaFlask className="inline text-blue-600" /> Lab: Problem Solving
            and Real Practice
          </h2>
          <p className="px-3 sm:px-6 lg:px-5">
            Tackle hundreds of problems across data structures, algorithms, SQL,
            system design, and API integrations. Work on real-world use cases
            through guided labs with hands-on debugging, refactoring, and
            optimization sessions.
          </p>
          <h2 className="my-12">
            <FaBagShopping className="inline text-blue-600" /> Tech Stack &
            Tools Covered
          </h2>
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-800">
            <div>
              <h3>Languages & Frameworks:</h3>
              <ul>
                <li>JavaScript (ES6+), Node.js, Express.js</li>
                <li>SQL (MySQL, PostgreSQL), MongoDB, Redis</li>
              </ul>
            </div>
            <div>
              <h3>Tools:</h3>
              <ul>
                <li>Git, GitHub, Postman, Docker, PM2</li>
                <li>Draw.io, Lucidchart, Figma, VS Code</li>
                <li>JMeter, Mocha, Chai, ESLint, Prettier</li>
              </ul>
            </div>
            <div>
              <h3>Cloud & DevOps:</h3>
              <ul>
                <li>AWS EC2, S3, Lambda, IAM</li>
                <li>GitHub Actions, NGINX, Docker Hub</li>
              </ul>
            </div>

            <div>
              <h3>System Design Aids:</h3>
              <ul>
                <li>UML Diagrams, DFD, Sequence Diagrams</li>
                <li>Queue Systems, Rate Limiting, Load Balancing</li>
              </ul>
            </div>
            <div>
              <h3>Project & Collaboration:</h3>
              <ul>
                <li>Jira, Trello, Notion, Slack</li>
              </ul>
            </div>
            <div>
              <h3>Security & API Auth:</h3>
              <ul>
                <li>JWT, OAuth, HTTPS, CORS, Helmet</li>
              </ul>
            </div>
          </div> */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {skillsData.map((section, index) => (
              <div key={index} className="p-4">
                <h3>{section.title}:</h3>
                <div>
                  {section.items.map((item, i) => (
                    <p key={i}>
                      <FaCheckCircle className="inline mr-2 text-green-600" />{" "}
                      {item}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="m-6 p-4 sm:px-6 lg:px-5">
          <h2 className="text-center mb-14">What You Will Learn</h2>
          <div className="relative border-l-4 border-gradient-to-b from-blue-500 to-purple-500 max-w-5xl mx-auto">
            {topics.map((topic, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative mb-12 pl-10 group"
              >
                {/* Animated Dot */}
                <div className="absolute -left-6 top-1">
                  <span className="block w-4 h-4 bg-gradient-to-br from-[#6A2FC1] to-[#3f2168] rounded-full animate-pulse"></span>
                </div>

                {/* Card */}
                <div className="bg-white shadow-xl rounded-xl p-5 transition-transform duration-300 group-hover:scale-[1.02] hover:shadow-2xl">
                  <div className="flex items-center space-x-4 mb-4">
                    {topic.icon}
                    <h3 className="mb-0">{topic.title}</h3>
                  </div>
                  <p>{topic.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Scholarship student  */}
        <section className="sm:px-6 lg:px-5">
          <h2 className="text-center my-12">🎓 Scholarship Students</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 justify-center items-center gap-6 lg:p-0 p-4">
            {scholarshipStudents.map((student, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative mb-12  group"
              >
                <div
                  key={index}
                  className="theme-background text-white rounded-xl p-4 shadow-md flex flex-col items-center justify-center text-center transition-transform duration-300 group-hover:scale-[1.02] hover:shadow-2xl min-h-72"
                >
                  <img
                    src={student.photo}
                    alt={student.name}
                    className="w-24 h-24 rounded-full mb-4 object-cover"
                  />
                  <h3 className="leading-none mb-0">{student.name}</h3>
                  
                  {student?.links && (
                    <div className="flex gap-3 mt-3">
                      {student?.links.map((link, index) => (
                        <Link key={index}
                        to={link?.link} 
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                          <span className="text-2xl">{link?.icon}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                  <p className="mt-3">
                    {student.university}- ({student.department})
                  </p>
                </div>
              </motion.div>
            ))}

            {slotsLeft > 0 &&
              Array.from({ length: slotsLeft })
              .map((_, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: scholarshipStudents.length * 0.1 }}
                  viewport={{ once: true }}
                  className="relative mb-12 group"
                >
                  <div className="theme-background text-white rounded-xl p-4 shadow-md flex flex-col items-center justify-center text-center transition-transform duration-300 group-hover:scale-[1.02] hover:shadow-2xl min-h-72">
                    <img
                      src={femalePhoto}
                      alt="student name"
                      className="w-24 h-24 rounded-full mb-4 object-cover"
                    />
                    <h3 className="leading-none mb-0">Your Name</h3>
                    <p className="mt-3">
                      University Name - (Your Department)
                    </p>
                  </div>
                </motion.div>
              ))
            }
          </div>

          <div className="mt-8 text-center">
            {slotsLeft > 0 ? (
              <>
                <section class="bg-blue-50 text-gray-800 py-10 px-6 md:px-12 rounded-2xl shadow-md max-w-3xl mx-auto my-10">
                  <h2 class="text-2xl md:text-3xl font-bold mb-4 text-blue-900 text-center">স্কলারশিপ (১০০% ফ্রি)</h2>
                  <p class="text-base md:text-lg leading-relaxed text-gray-700">
                    শুধুমাত্র অত্যন্ত উৎসাহী টেক ক্যারিয়ার গড়ে তুলতে এবং আর্থিকভাবে সক্ষম না হওয়ায় উন্নত কোর্স করার সুযোগ পাচ্ছে না এমন শিক্ষার্থীদের জন্য এই স্কলারশিপ।
                    <span class="font-semibold text-blue-800">মেয়েদের জন্য উচ্চ অগ্রাধিকার ভিত্তিতে ১ টি সিট এখনও খালি রয়েছে।</span>
                    শর্ত শুধু একটাই — আপনি হতে হবে <span class="font-medium text-gray-900">মেধাবী, আগ্রহী</span> এবং <span class="italic text-blue-700">সত্যিকারের শিক্ষার জন্য উদগ্রীব</span>।
                  </p>
                </section>

                <div className="flex flex-col sm:flex-row items-center gap-4 justify-center mt-6">
                  <Link
                    to="/contact"
                    className="btn-primary w-80 text-center"
                    // target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apply Scholarship ({slotsLeft} slot{slotsLeft > 1 ? "s" : ""} left)
                  </Link>

                  <button
                    className="inline-flex items-center justify-center w-80 px-6 py-3 bg-white text-blue-700 border border-blue-700 font-semibold rounded-lg shadow hover:bg-blue-700 hover:text-white transition duration-200"
                    onClick={() => setIsOpen(true)}
                  >
                    View Scholarship Agreement
                  </button>

                </div>

                <ScholarshipAgreementModal isOpen={isOpen} onClose={() => setIsOpen(false)} />

              </>
              
       
            ) : (
              <p className="text-red-600 font-semibold text-lg">
                All scholarship slots are filled. 
              </p>
            )}
          </div>
        </section>

        <InstructorCard />
      </div>
    </>
  );
}

const skillsData = [
  {
    title: "Languages, Frameworks & Databases",
    items: [
      "JavaScript (ES6+) – A high-level, versatile programming language for developing interactive front-end and scalable back-end applications.",
      "SQL (MySQL, PostgreSQL), MongoDB, Redis – Comprehensive relational and NoSQL database solutions for managing structured, unstructured, and in-memory data.",
      "Node.js – An event-driven, non-blocking runtime environment for executing JavaScript on the server side.",
      "Express.js – A minimal and flexible Node.js framework for building robust RESTful APIs.",
      "Sequelize ORM – A promise-based Object-Relational Mapping tool for managing SQL databases in Node.js applications.",
    ],
  },
  {
    title: "Security & API Authentication",
    items: [
      "Secure access control using OAuth2, JWT, API keys, and sessions.",
      "Input validation and output sanitization to prevent attacks.",
      "SSL/TLS encryption for secure data transmission.",
      "Rate limiting to protect against abuse and DoS attacks.",
      "API versioning for backward compatibility.",
      "CSRF and XSS protection with CSP and CORS policies.",
      "Secure management of keys, tokens, and secrets.",
      "Data encryption at rest and in transit.",
      "Centralized logging and monitoring for security auditing.",
      "Continuous vulnerability testing and management.",
    ],
  },
  {
    title: "System Design Aids",
    items: [
      "UML Diagrams – Includes class and component diagrams to ensure architectural clarity and maintainability.",
      "Data Flow Diagrams (DFDs) – Visual tools for representing how data moves through the system.",
      "Sequence Diagrams – Illustrate the sequence of interactions between system components or services.",
      "Rate Limiting, Load Balancing, Queue Systems – Key techniques to enhance scalability, availability, and traffic management.",
      "API Gateway Patterns – Best practices for securing, routing, and managing API traffic efficiently.",
    ],
  },

  {
    title: "Cloud & DevOps",
    items: [
      "Amazon Web Services (AWS): EC2, S3, ECS, ECR, Lambda, IAM – Core cloud services for compute, storage, container orchestration, serverless architecture, and access control.",
      "Docker – Platform for containerizing applications to ensure consistency across development and production environments.",
      "GitHub Actions – CI/CD automation for continuous integration, testing, and deployment workflows.",
    ],
  },
  {
    title: "Project Management & Collaboration",
    items: [
      "Trello / GitHub Projects – Agile tools for sprint planning, task tracking, and team collaboration.",
      "Draw.io / Lucidchart – Diagramming platforms for system design, architecture visualization, and planning.",
      "Slack – Real-time communication and collaboration tool for development teams.",
    ],
  },
  {
    title: "Development Tools",
    items: [
      "Git, GitHub, Postman, Docker, PM2 – Tools for version control, API testing, containerization, and process management.",
      "Draw.io, Lucidchart, Figma, VS Code – Visual design, wireframing, and code editing tools used throughout the development lifecycle.",
      "JMeter, Mocha, Chai, ESLint, Prettier – Testing, assertion, performance benchmarking, and code quality enforcement tools.",
    ],
  },
];

const topics = [
  {
    icon: <FaLaptopCode className="text-blue-600 text-2xl" />,
    title: "Computer Science Fundamentals",
    description:
      "Master the foundational principles of computing including Operating Systems, Networking, Data Structures, Algorithms, and Computer Architecture to build a strong technical base.",
  },
  {
    icon: <FaCode className="text-green-600 text-2xl" />,
    title: "Comprehensive JavaScript Programming",
    description:
      "Acquire in-depth knowledge of JavaScript from fundamentals to advanced concepts, coupled with practical coding exercises and problem-solving challenges.",
  },
  {
    icon: <FaDatabase className="text-purple-600 text-2xl" />,
    title: "Database Design and Development",
    description:
      "Develop expertise in designing, implementing, and optimizing relational and NoSQL databases using MySQL, MongoDB, and advanced querying techniques.",
  },
  {
    icon: <FaServer className="text-red-600 text-2xl" />,
    title: "API Design and Integration",
    description:
      "Learn to architect and build secure, scalable RESTful APIs and integrate essential third-party services such as payment processors and shipping providers.",
  },
  {
    icon: <FaProjectDiagram className="text-yellow-600 text-2xl" />,
    title: "Project Management and Agile Methodologies",
    description:
      "Gain proficiency in Agile frameworks, Software Development Life Cycle (SDLC), task tracking with tools like Jira and Trello, Git-based version control, and team collaboration best practices.",
  },
  {
    icon: <FaAws className="text-orange-600 text-2xl" />,
    title: "Cloud Computing with AWS",
    description:
      "Hands-on experience with core AWS cloud services including EC2, S3, Lambda, IAM, container orchestration, and monitoring to build scalable, cloud-native applications.",
  },
  {
    icon: <FaCogs className="text-indigo-600 text-2xl" />,
    title: "System Design and Software Architecture",
    description:
      "Learn to design robust, scalable, and maintainable systems leveraging microservices, event-driven architectures, API gateways, caching, and load balancing strategies.",
  },
  {
    icon: <FaCubes className="text-pink-600 text-2xl" />,
    title: "Continuous Integration and Deployment (CI/CD)",
    description:
      "Implement automated build, test, and deployment pipelines using Docker, GitHub Actions, and modern DevOps practices to ensure rapid and reliable software delivery.",
  },
  {
    icon: <FaLaptopCode className="text-teal-600 text-2xl" />,
    title: "Capstone Projects",
    description:
      "Apply your skills to build full-stack, production-ready applications that simulate real-world industry challenges, preparing you for professional software engineering roles.",
  },
];

const highlights = [
  {
    title: "Industry-Aligned Curriculum",
    description:
      "Covers modern backend technologies including JavaScript, Node.js, MySQL, REST APIs, Cloud & AWS, Microservices, Kafka, Redis, Docker, and CI/CD. Emphasizes hands-on projects to apply each concept in a real-world context.",
  },
  {
    title: "Project-Based Learning",
    description:
      "Build a stock trading backend, a full-stack e-commerce system, and a microservices platform on AWS. Each semester includes a real-world capstone project to enhance your portfolio.",
  },
  {
    title: "End-to-End SDLC Experience",
    description:
      "Master the full software development lifecycle — from requirement analysis to deployment and monitoring. Learn system design, architecture, testing, and security like a mid-level engineer.",
  },
  {
    title: "DevOps & Cloud Exposure",
    description:
      "Get hands-on with CI/CD pipelines using GitHub Actions and Docker. Deploy cloud-native apps on AWS using ECS, EC2, S3, Lambda, and more.",
  },
  {
    title: "Career-Focused Training",
    description:
      "Gain skills aligned with in-demand global tech roles. Build depth and breadth — not just coding, but also infrastructure, design, and scalability.",
  },
];

const phases = [
  {
    title: "Phase 1: Foundation & Fundamentals",
    description: `
        Build a strong base in core computer science concepts and backend fundamentals.
        Topics include:
        - JavaScript & Object-Oriented Programming
        - Data Structures & Algorithms
        - Relational & NoSQL Database Design
        - Node.js & Express API Development
        - Building a secure trading application`,
  },
  {
    title: "Phase 2: Systems & Architecture",
    description: `
        Advance your understanding of backend engineering through real-world system development.
        Topics include:
        - API Integration & Security
        - Linux & Database Administration
        - Scalable System Design
        - Software Testing & CI/CD Pipelines
        - Full-stack eCommerce Platform Project`,
  },
  {
    title: "Phase 3: Cloud & Capstone",
    description: `
        Gain deep expertise in cloud-native architecture and modern DevOps practices.
        Topics include:
        - AWS Services (EC2, S3, Lambda, ECS)
        - Kafka, Redis, Microservices
        - Docker, CI/CD Automation
        - System Monitoring & Observability
        - Capstone: Deploying production-grade backend on the cloud`,
  },
];
